import { Drawer, Form, Space } from "antd";
import React, { useEffect, useRef } from "react";
import { ButtonUi } from "../../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../../types/typesConstants";
import { FormUi } from "../../../ui/FormUi";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  rutaClearActive,
  rutaStartAdd,
  rutaStartUpdate,
} from "../../../../actions/usuario";
import { RutaForm } from "./RutaForm";
const initialValues = {
  id: dayjs(),
  nombre: null,
  rutapadre: null,
  path: null,
  eslink: false,
  esvisible: true,
  orden: 0,
  modulo: null,
  componente: null,
  icono: null,
};
const useResetFormOnCloseDrawer = ({ form, open, activeRuta }) => {
  const dispatch = useDispatch();
  const prevOpenRef = useRef();
  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;

  useEffect(() => {
    if (!open && prevOpen) {
      dispatch(rutaClearActive());
      form.resetFields();
    }
    if (open) {
      //Abrir Modal
      if (activeRuta)
        //entro editar
        form.setFieldsValue({ ...activeRuta });
      //entro nuevo
      else form.setFieldsValue({ id: new dayjs().valueOf() });
    }
  }, [form, prevOpen, open]);
};
export const RutaDrawer = ({
  open,
  handleCloseDrawer,
  handleTreeNodeClearSelected,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { activeRuta, activeModulo } = useSelector((state) => state.usuario);
  useResetFormOnCloseDrawer({ form, open, activeRuta });
  const handleClose = () => {
    dispatch(rutaClearActive());
    handleCloseDrawer();
    handleTreeNodeClearSelected();
  };
  const handleSubmit = (values) => {
    values = {
      ...values,
      rutapadre:
        typeof values?.rutapadre === "undefined" ? null : values?.rutapadre,
      modulo: activeModulo?.id,
    };
    if (activeRuta) dispatch(rutaStartUpdate(values));
    else dispatch(rutaStartAdd(values));
    handleClose();
  };
  return (
    <Drawer
      title="Rutas de acceso"
      onClose={handleClose}
      open={open}
      destroyOnHidden
      maskClosable={false}
      size="large"
      styles={{
        body: {
          paddingBottom: 80,
        },
      }}
      extra={
        <Space>
          <ButtonUi
            typeUi={TipoButtonConstants.Cancelar}
            onClick={handleClose}
          />
          <ButtonUi
            typeUi={TipoButtonConstants.Guardar}
            htmlType="submit"
            form="FormRuta"
          />
        </Space>
      }
      forceRender
    >
      <FormUi
        name="FormRuta"
        form={form}
        layout="vertical"
        autoComplete="off"
        initialValues={initialValues}
        hideRequiredMark
        handleSubmit={handleSubmit}
      >
        <RutaForm />
      </FormUi>
    </Drawer>
  );
};
